import { EnhancedPageContentWrapper as EnhancedPageContent } from "./EnhancedPageContent";
import { LoadingPageContent } from "./LoadingPageContent";
import { MinimalPageContentWrapper as MinimalPageContent } from "./MinimalPageContent";
import { ExperimentLayers } from "../../../statsig/experiments";
import { StatsigLoadingContext } from "../../../statsig/StatsigProvider";
import { useContext } from "react";
import { useLayer } from "@statsig/react-bindings";

export type PageContentProps = {
  isLoading: boolean;
  clientIntroStateV2IsEnabled: boolean;
  className?: string;
  minimalPageContentComponent: typeof MinimalPageContent;
  enhancedPageContentComponent: typeof EnhancedPageContent;
  drawerId: string;
};
export function PageContentComponent({
  isLoading,
  clientIntroStateV2IsEnabled,
  className,
  minimalPageContentComponent: MinimalPageContentComponent,
  enhancedPageContentComponent: EnhancedPageContentComponent,
  drawerId,
}: PageContentProps) {
  if (isLoading) return <LoadingPageContent />;

  if (clientIntroStateV2IsEnabled)
    return (
      <EnhancedPageContentComponent className={className} drawerId={drawerId} />
    );

  return <MinimalPageContentComponent className={className} />;
}

export type PageContentWrapperProps = { className?: string; drawerId: string };

export function PageContent({ className, drawerId }: PageContentWrapperProps) {
  const [layerName, layerConfig] = ExperimentLayers.ClientWaitingRoom;
  const layer = useLayer(layerName);
  const shouldShowAVSetup = layer.get<boolean>(
    layerConfig.ShouldShowAvSetup,
    false,
  );
  const isLoading = useContext(StatsigLoadingContext);

  return (
    <PageContentComponent
      isLoading={isLoading}
      clientIntroStateV2IsEnabled={shouldShowAVSetup}
      className={className}
      minimalPageContentComponent={MinimalPageContent}
      enhancedPageContentComponent={EnhancedPageContent}
      drawerId={drawerId}
    />
  );
}
